import React, { Fragment } from "react";
import {Link} from 'react-router-dom';
import './Navbar.scss';

const Navbar = () => {
  return (
    <Fragment>
      <div className="navbar">
        <div className="container-nav">
          <Link className="logo" to="/">
            <p className="crew">CabinCrew<span>Essentials</span></p>
          </Link>

          <nav>
            <ul className="primary-nav">
              <li>
                <Link className="current" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
            </ul>

          </nav>
        </div>
      </div>
    </Fragment>
  );
};

export default Navbar;
